<template>
    <v-row>
        <v-col cols="12">
            <div class="text-h5 font-weight-bold mb-6 text-[#0676C2]">{{ $t('referrers.your_referrals') }}</div>

            <div class="text-body-2 font-weight-bold mb-1">{{ $t('referrers.Invitations sent') }}</div>

            <div class="text-body-2 mb-4">{{ $t('referrers.Check who you have already invited to the referral program') }}:</div>

            <div v-if="(!emails || (emails && emails.length < 1))" class="border rounded-pill bg-amber-accent-2 py-1 px-3 d-inline-block text-sm my-4">
              {{ $t('referrers.no_invites_yet') }}
            </div>
            <div class="text-body-2" v-for="email in emails">
                {{ email }}
            </div>

            <div class="text-body-2 font-weight-bold mt-6">{{ $t('referrers.Invitations confirmed') }}</div>
            <div class="text-body-2 mt-2">{{ $t('referrers.keep_track_invitees') }}</div>
            <div v-if="(!referrals || (referrals && referrals.length < 1))" class="border rounded-pill bg-amber-accent-2 py-1 px-3 d-inline-block text-sm my-4">
              {{ $t('referrers.no_approved_invites_yet') }}
            </div>
            <v-row
                v-else
                class="mt-3"
                no-gutters>
                <v-col cols="4">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.name') }}</span>
                </v-col>
                <v-col cols="2" class="text-center">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.date_submitted') }}</span>
                </v-col>
                <v-col cols="2" class="text-center">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.received_quote') }}</span>
                </v-col>
                <v-col cols="2" class="text-center">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.accepted_offer') }}</span>
                </v-col>
                <v-col cols="2" class="text-center">
                    <span class="text-caption text-info text-uppercase font-weight-bold">{{ $t('referrers.installed') }}</span>
                </v-col>
                <template v-for="refer in referrals">
                    <v-col cols="4" class="my-3 overflow-hidden">
                        <span class="text-caption">{{refer.name}}</span>
                    </v-col>
                    <v-col cols="2" class="text-center my-3">
                        <span class="text-caption">{{refer.date}}</span>
                    </v-col>
                    <v-col cols="2" class="text-center my-3">
                        <span class="text-caption"><v-icon v-if="refer.received" icon="mdi-check" color="success"></v-icon></span>
                    </v-col>
                    <v-col cols="2" class="text-center my-3">
                        <span class="text-caption"><v-icon v-if="refer.accepted" icon="mdi-check" color="success"></v-icon></span>
                    </v-col>
                    <v-col cols="2" class="text-center my-3">
                        <span class="text-caption"><v-icon v-if="refer.installed" icon="mdi-check" color="success"></v-icon></span>
                    </v-col>
                    <v-col cols="12"><v-divider/></v-col>
                </template>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: "ReferralsDashboard",
  props: [
      'referrals', 'emails'
  ],
}
</script>

